export { addTelemetryDebug, addTelemetryError, startFakeTelemetry, resetTelemetry, startTelemetry, isTelemetryReplicationAllowed, addTelemetryConfiguration, } from './telemetry';
export * from './rawTelemetryEvent.types';
export * from './telemetryEvent.types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/domain/telemetry/index.js
// module id = 427
// module chunks = 0